export { default as FiletypeDocument } from './filetype-document';
export { default as FiletypeImage } from './filetype-image';
export { default as FiletypeOther } from './filetype-other';
export { default as FiletypePdf } from './filetype-pdf';
export { default as FiletypePresentation } from './filetype-presentation';
export { default as FiletypeSpreadsheet } from './filetype-spreadsheet';
export { default as FiletypeVideo } from './filetype-video';
export { default as FiletypeZip } from './filetype-zip';



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/index.js